import React, { Children } from 'react';

import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

import Slide from '@mui/material/Slide';
import { TransitionProps } from '@mui/material/transitions';

const Transition = React.forwardRef(function Transition(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  props: TransitionProps & { children: React.ReactElement<any, any> },
  ref: React.Ref<unknown>,
) {
  return (
    <Slide direction="up" ref={ref} {...props}>
      {props.children}
    </Slide>
  );
});

type Props = {
  content: string | Array<string>;
  title: string;
  option0Text: string;
  option1Text?: string;
  sendUserClick: React.Dispatch<0 | 1>;
  open: boolean;
};

export const AlertDialog: React.FC<Props> = ({
  content,
  title,
  option0Text,
  option1Text,
  sendUserClick,
  open,
}) => {
  const handleClose = (optionClicked: 0 | 1) => {
    //setOpen(false);
    sendUserClick(optionClicked);
  };

  const usedContent = Array.isArray(content) ? content : [content];

  return (
    <React.Fragment>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        onClose={handleClose}
        aria-labelledby="alert-dialog-{title}"
      >
        <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {usedContent.map((line, index) => (
              <span key={index}>
                {line}
                <br />
                <br />
              </span>
            ))}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => handleClose(0)} color="primary">
            {option0Text}
          </Button>
          {option1Text && (
            <Button onClick={() => handleClose(1)} color="primary" autoFocus>
              {option1Text}
            </Button>
          )}
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};
